import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, first, map } from 'rxjs';
import { selectSelectedCompany, selectUserProfile } from 'src/app/auth/store/auth.selectors';
import { onUntouched } from '../loading-state/loadable';
import { getSubscription } from './store/subscription.actions';
import { selectSubscription } from './store/subscription.selectors';

export const blockHailOnly: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectSubscription),
    store.select(selectSelectedCompany),
    store.select(selectUserProfile),
  ]).pipe(
    filter(([, company, user]) => !!company && !!user),
    onUntouched(() => store.dispatch(getSubscription()), 0),
    first(([subscription]) => !subscription.isLoading && subscription.value !== undefined),
    map(([subscription, , user]) => {
      if (user!.is_staff || user!.is_superuser) return true;
      if (subscription.value?.isHailOnly) return router.createUrlTree(['auth', 'zeva-access']);
      return true;
    })
  );
};
